import { CloseIcon } from '@chakra-ui/icons';
import { IconButton, IconButtonProps } from '../../../IconButton';

type ClearButtonProps = Omit<IconButtonProps, 'aria-label'> & {
  name?: string;
  visible?: boolean;
};

const ClearButton = ({ name, visible = false, ...props }: ClearButtonProps) =>
  visible ? (
    <IconButton
      size="sm"
      aria-controls={name}
      aria-label="Clear Input"
      icon={<CloseIcon fontSize="sm" />}
      sx={{
        color: 'gray.400',
        display: 'inline-block',
        w: 'auto',
        minW: 0,
        pl: 3,
        pr: 3,
        borderRadius: 0,
        letterSpacing: 0,
        bgColor: 'transparent',
        _hover: {
          bgColor: 'transparent',
        },
        _focus: {
          bgColor: 'transparent',
        },
      }}
      variant="unstyled"
      {...props}
    />
  ) : null;

export default ClearButton;
